module.exports = __webpack_public_path__ + "img/ic-download-excel.f7992ad9.svg";